import LazyLoad from "vanilla-lazyload";

function initLazyLoadInstance() {
    var lazyLoadInstance = new LazyLoad({});
    window.lazyLoadInstance = lazyLoadInstance;
}

initLazyLoadInstance();
